import { Builder } from '@builder.io/react';

import dynamic from 'next/dynamic';


// Variants Component


Builder.registerComponent(
    dynamic(() => import('../components/variants').then(mod => mod.ProductVariants as any)),
    {
        name: "Product Variants",
        inputs: [
            {
                name: "isOpen",
                type: "boolean",
            },
            {
                name: "data",
                type: "list"
            }
        ],
    }
);


Builder.registerComponent(
    dynamic(
        () => import('../components/quantity-input/quantity-input')
        .then(mod => mod.QuantityInput as any)),
    {
        name: "Quantity Input",
        inputs: [
            {
                name: "isOpen",
                type: "boolean",
            },
            {
                name: "data",
                type: "list"
            }
        ],
    }
);